/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { CreateCustomerContactResponseJson } from './create-customer-contact-response-json';
import { CreateCustomerContactResult } from '../results/create-customer-contact-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CustomerContactDto } from '../models/customer-contact-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class CreateCustomerContactResponse extends ResponseWithErrorGeneric<CreateCustomerContactResponseJson, CreateCustomerContactResult> implements IResponseWithErrorGeneric<CreateCustomerContactResult> {
  public customerContact: CustomerContactDto;

  //<custom-body>
  constructor(response: HttpResponse<CreateCustomerContactResponse>) {
    super(response, CreateCustomerContactResult.Error);

    if (this.result !== CreateCustomerContactResult.Success) {
      return;
    }
      
    this.customerContact = new CustomerContactDto(this.body.customerContact);
  }
  //</custom-body>
}
